import React from "react";
import axios from "axios";
import { Row, Container, Col } from "react-bootstrap";
import { withRouter } from "react-router";
import { t } from "../../../localization/localization";

import wosLogo from "../../../assets/wos_logo.png";

class DashboardExternalWos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
    };
  }

  componentDidMount() {
    this.getExternalWos();
  }

  getExternalWos = () => {
    axios
      .get(
        `${window._env_.BASE_URL}/gcris-api/researcher/${this.props.crisId}/external-metrics/wos`
      )
      .then((res) => {
        this.setState({ data: res.data });
      });
  };

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";

    if (!this.state.data || !this.state.data?.wosResearcherId) {
      return null;
    }
    return (
      <Container fluid>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href={`https://www.webofscience.com/wos/author/record/${this.state.data.wosResearcherId}`}
          style={{ textDecoration: "none" }}
        >
          <Row className="wall">
            <Col>
              <img src={wosLogo} style={{ height: 36, marginBottom: 16 }} />
              <Row className="justify-content-center text-center">
                <Col xs="6" md="4">
                  <div>
                    <h1 style={{ color: "#001F54" }}>
                      {this.state.data.documentcount ?? "-"}
                    </h1>
                    <h6 style={{ color: "#275DAD" }}>
                      {t(
                        locale,
                        "/rs/profile/dashboardExternalWos/institution-affiliated-articles"
                      )}
                    </h6>
                  </div>
                </Col>
                <Col xs="6" md="4">
                  <div>
                    <h1 style={{ color: "#001F54" }}>
                      {this.state.data.citedby ?? "-"}
                    </h1>
                    <h6 style={{ color: "#275DAD" }}>
                      {t(
                        locale,
                        "/rs/profile/dashboardExternalWos/institution-affiliated-citations"
                      )}
                    </h6>
                  </div>
                </Col>
              </Row>
              <Row className="text-center">
                WoS{t(locale, "/rs/profile/valid-for-all-publications")}
              </Row>
            </Col>
          </Row>
        </a>
      </Container>
    );
  }
}

export default withRouter(DashboardExternalWos);
